<template>
    <div id="app">
        <router-view/>
        <footer class="footer o-footer">
            <img src="@/assets/logo.png" alt="Agrii">
            <p>v{{ version }}</p>
        </footer>
    </div>
</template>

<script>
export default {
    computed: {
        adviceStatus() {
            return this.$store.getters.adviceStatus
        },
        version() {
            return process.env.PACKAGE_VERSION
        }
    },
    created() {
        if(this.$route.params.token) {
            this.$store.dispatch('fetchContent', this.$route.params.token).then(() => {
                if(this.$route.name === 'loading'){
                    if(this.adviceStatus == 'discharged') {
                        this.$store.dispatch('setEmptyInfo', 'Transport został już dostarczony.')
                        this.$router.push({ name: 'empty' })
                    }
                    if(this.adviceStatus == 'waste') {
                        this.$store.dispatch('setEmptyInfo', 'Transport został odrzucony.')
                        this.$router.push({ name: 'empty' })
                    }
                    if(this.adviceStatus == 'received') {
                        this.$router.push({ name: 'unloading' })
                    }
                }
            })
        } else {
            this.$store.dispatch('setEmptyInfo', 'Brak prawidłowego tokenu')
            if(this.$route.path !== '/'){
                this.$router.push({ name: 'empty' })
            }
        }
    }
}
</script>